import React, {Component} from 'react'
import TableHeadReport from './TableHeadReport'
import TableBodyReport from './TableBodyReport'

class TableReport extends Component {
    render() {
        const {data, dataLabels, typeReport, periodType} = this.props
        return (
            <div className='TableReport mt-4'>
                <table className='table'>
                    <TableHeadReport dataLabels={dataLabels}/>

                    <TableBodyReport data={data} typeReport={typeReport} periodType={periodType}/>
                </table>
            </div>
        )
    }
}

export default TableReport
